//client/src/components/layout/PageHeader.js
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, MoreVertical } from 'lucide-react';

/**
 * Cabeçalho padrão de todas as páginas do painel.
 * @param {React.ReactNode} props.icon - Ícone Lucide
 * @param {string} props.title - Título da página
 * @param {string|React.ReactNode} props.subtitle - Texto auxiliar (apenas desktop)
 * @param {React.ReactNode} props.actions - Botões de ação; colapsa em dropdown no mobile
 * @param {{ to: string, text?: string }} props.navBack - Botão "voltar" com rota
 */
const PageHeader = ({ icon, title, subtitle, actions, navBack }) => {
    const navigate = useNavigate();
    const [mobileOpen, setMobileOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (!mobileOpen) return;
        const handler = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setMobileOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [mobileOpen]);

    return (
        <div className="page-header">
            <div className="page-header-left">
                {navBack && (
                    <button
                        type="button"
                        onClick={() => navigate(navBack.to)}
                        className="action-button action-button-secondary"
                    >
                        <ArrowLeft size={16} />
                        {navBack.text || 'Voltar'}
                    </button>
                )}
                <div className="page-header-title-group">
                    <h1 className="page-title">
                        {icon && React.cloneElement(icon, {
                            className: 'icon-title',
                            'aria-hidden': true,
                            size: icon.props.size || 22,
                        })}
                        {title}
                    </h1>
                    {subtitle && <p className="page-subtitle">{subtitle}</p>}
                </div>
            </div>

            {/* Desktop: barra de ações normal (oculta no mobile via CSS) */}
            {actions && (
                <div className="actions-bar page-header-desktop-actions">
                    {actions}
                </div>
            )}

            {/* Mobile: botão ⋮ + dropdown (oculto no desktop via CSS) */}
            {actions && (
                <div className="page-header-mobile-menu" ref={dropdownRef}>
                    <button
                        type="button"
                        className="page-header-mobile-btn"
                        onClick={() => setMobileOpen(p => !p)}
                        aria-label="Mais ações"
                        aria-expanded={mobileOpen}
                    >
                        <MoreVertical size={20} />
                    </button>
                    {mobileOpen && (
                        <>
                            {/* Escurece o resto da página enquanto o menu está aberto — sem
                                isso, o dropdown (position:absolute, não empurra o conteúdo
                                abaixo) ficava visualmente colado no card de perfil logo
                                depois do header, parecendo que "Remover foto" fazia parte
                                do mesmo menu que "Salvar Perfil". */}
                            <div
                                className="page-header-backdrop"
                                onClick={() => setMobileOpen(false)}
                            />
                            <div
                                className="page-header-dropdown"
                                onClick={() => setMobileOpen(false)}
                            >
                                {actions}
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default PageHeader;
